import { ref, onMounted, watchEffect, reactive } from '@nuxtjs/composition-api';
import { createPopperLite as createPopper } from '@popperjs/core';
import { useOutsideClick } from './useOutsideClick';

/**
 * Popper hook
 *
 * @param {*} [options] optional options popper
 * @param {array} [options.placement] popper placement
 * @param {array} [options.offset] offset x and y as an array [x,y]
 *
 * @returns [triggerRef, popperContainerRef, popperStateAndToggler]
 */
export function usePopper({ placement = 'bottom-end', offset = [0, 0], ...popperOptions } = {}) {
  const offsetPopperModifier = { modifiers: [{ name: 'offset', options: { offset } }] };
  const options = { placement, ...offsetPopperModifier, ...popperOptions };
  const reference = ref(null);
  const popper = ref(null);

  const isPopperVisible = ref(false);
  const toggle = () => (isPopperVisible.value = !isPopperVisible.value);
  const show = () => (isPopperVisible.value = true);
  const hide = () => (isPopperVisible.value = false);

  onMounted(() => {
    watchEffect((onInvalidate) => {
      let popperEl;
      // vue 2 ref sorunu: Custom Component'larda ref verirken $el kullanmak gerekiyor
      if (popper.value && popper.value.$el) {
        popperEl = popper?.value && popper?.value?.$el;
      } else {
        popperEl = popper?.value?.el || popper?.value;
      }

      let referenceEl;
      // vue 2 ref sorunu: Custom Component'larda ref verirken $el kullanmak gerekiyor
      if (reference.value && reference.value.$el) {
        referenceEl = reference.value && reference.value.$el;
      } else {
        referenceEl = reference.value.el || reference.value;
      }

      useOutsideClick(popperEl, (e) => {
        // tikladigi element(referenceEl) degil ise
        if (isPopperVisible.value && !referenceEl.contains(e.target)) {
          isPopperVisible.value = false;
        }
      });

      if (!(referenceEl instanceof HTMLElement)) return;
      if (!(popperEl instanceof HTMLElement)) return;

      const { destroy } = createPopper(referenceEl, popperEl, options);

      onInvalidate(destroy);
    });
  });
  const popperState = reactive({
    visible: isPopperVisible,
    toggle,
    show,
    hide,
  });
  return [reference, popper, popperState];
}
